import React, { useMemo } from "react";
import DOMPurify from "dompurify";

const TABLE_STYLES = `
  <style>
    .hp-root table {
      border-collapse: collapse !important;
      border-spacing: 0 !important;
      width: 100% !important;
      border: 1px solid #9aa4b2 !important;
      margin: 8px 0 !important;
    }
    .hp-root table td,
    .hp-root table th {
      border: 1px solid #9aa4b2 !important;
      padding: 8px 10px !important;
      text-align: left !important;
      font-size: 13px !important;
      color: #1f2937 !important;
    }
    .hp-root table th {
      background-color: #f8fafc !important;
      font-weight: 600 !important;
    }
    .hp-root table tr {
      border: 1px solid #9aa4b2 !important;
    }
    .hp-root p {
      margin: 4px 0 !important;
      font-size: 13px !important;
      color: #1f2937 !important;
    }
  </style>
`;

export default function HtmlPreview({ html }) {
  const safe = useMemo(() => {
    const sanitized = DOMPurify.sanitize(html || "", {
      USE_PROFILES: { html: true },
      ADD_ATTR: [
        "style",
        "border",
        "cellpadding",
        "cellspacing",
        "width",
        "align",
        "valign",
        "colspan",
        "rowspan",
      ],
      FORCE_BODY: true,
    });

    // Wrap with scoped class + inject style tag
    return `${TABLE_STYLES}<div class="hp-root">${sanitized}</div>`;
  }, [html]);

  return (
    <div
      className="html-preview-wrap"
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}